import { Modal, ModalOverlay, ModalContent, Flex, ModalBody, Text, Box, Image, useToast } from '@chakra-ui/react'
import React, { useContext, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthContext } from '../../../../AuthProvider'

import checkWhiteIcon from '../../../../assets/check_circle_white.svg'
import closeWhiteIcon from '../../../../assets/cross_white_24.svg'
import { Button } from '@ubirider/pick-component-library'
import { deleteVehicle } from '../../../../api/vehicles'
import { useVehicles } from '../../../../context/DataProvider'

export function DeleteVehicleModal(props) {
  const [loading, setLoading] = useState(false)

  const toast = useToast()
  const toastIdRef = useRef()

  const { refetch } = useVehicles()

  function close() {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current)
    }
  }
  const handleClickDelete = async () => {
    try {
      setLoading(true)
      await deleteVehicle(props.licensePlate)
      await refetch()
      setLoading(false)
      props.onClose()
      toastIdRef.current = toast({
        position: 'top',
        duration: 5000,
        isClosable: true,
        render: () => (
          <Box
            alignItems='center'
            color='white'
            bg='#01AE70'
            border='1px solid #067F5B'
            boxShadow='box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05)'
            borderRadius='4px'
          >
            <Flex justifyContent='space-between' gap='16px' padding='16px'>
              <Image src={checkWhiteIcon} />
              <Text fontSize='14px' fontWeight='600'>
                Veículo eliminado
              </Text>
              <Image cursor='pointer' onClick={close} src={closeWhiteIcon} />
            </Flex>
          </Box>
        ),
      })
    } catch (error) {
      console.error(error)
    }
  }

  const { t } = useTranslation()

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      onOpen={props.onOpen}
      size={{ sm: 'xs', md: 'xl', lg: 'xl', xl: 'xl' }}
      closeOnOverlayClick={false}
      autoFocus={false}
      isCentered
    >
      <ModalOverlay />
      <ModalContent padding={{ sm: '16px 24px', md: '16px 24px', lg: '32px', xl: '32px' }}>
        <Flex direction='column' gap='48px'>
          <Flex direction='column' gap='16px'>
            <Text fontWeight='700' fontSize={{ sm: '20px', md: '20px', lg: '24px', xl: '24px' }} color='neutral.800'>
              {t('acqua_vias.delete_vehicle_dialog_title')}
            </Text>
            <Text fontWeight='600' fontSize={{ sm: '14px', md: '14px', lg: '16px', xl: '16px' }} color='neutral.600'>
              {t('acqua_vias.delete_vehicle_dialog_description')}
            </Text>
          </Flex>

          <Flex
            w='100%'
            gap='16px'
            justifyContent='flex-end'
            display={{ sm: 'none', md: 'none', lg: 'flex', xl: 'flex' }}
          >
            <Button
              onClick={handleClickDelete}
              loading={loading}
              style='solid'
              type='danger'
              label={t('common.delete')}
              css={{ width: '160px' }}
            />
            <Button
              onClick={props.onClose}
              style='outline'
              type='neutralDark'
              label={t('common.cancel')}
              css={{ width: '160px' }}
            />
          </Flex>
          <Flex
            gap='16px'
            alignSelf='stretch'
            direction='column'
            display={{ sm: 'flex', md: 'flex', lg: 'none', xl: 'none' }}
          >
            <Button
              onClick={props.onClose}
              style='outline'
              type='neutralDark'
              label={t('common.cancel')}
              css={{ width: '100%' }}
            />
            <Button
              onClick={handleClickDelete}
              loading={loading}
              style='solid'
              type='danger'
              label={t('common.delete')}
              css={{ width: '100%' }}
            />
          </Flex>
        </Flex>
      </ModalContent>
    </Modal>
  )
}
